import { putCampaignEmail } from '../services/putCampaignEmail';
export const updateCampaign = (payload, campaignId) => putCampaignEmail(payload, campaignId);
